import { useEffect } from 'react';

import { useSoyuzExperiment } from '@spotahome/soyuz/client';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import './ZohoChatbot.scss';

const ZohoChatbot = () => {
  const shouldAddListener =
    useSoyuzExperiment('ZohoChatbot').get('behaviour') === 'variant';

  const handleClick = () => {
    const chatOpened = document
      .querySelector('#zsiq_chat_wrap')
      ?.classList.contains('chat-iframe-open');

    SoyuzAnalytics.sendGA4Event('send', {
      context: 'ZohoChat',
      action: chatOpened ? 'Open' : 'Close',
      value: 'click'
    });
  };

  useEffect(() => {
    if (!shouldAddListener) {
      return undefined;
    }

    let zohoChatElement = document.querySelector('#zsiq_float');
    let observer;
    let listenerAdded = false;

    const addListener = element => {
      if (element && !listenerAdded) {
        element.addEventListener('click', handleClick);
        listenerAdded = true;
      }
    };

    if (!zohoChatElement) {
      observer = new MutationObserver(() => {
        zohoChatElement = document.querySelector('#zsiq_float');
        if (zohoChatElement) {
          addListener(zohoChatElement);
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    } else {
      addListener(zohoChatElement);
    }

    return () => {
      if (zohoChatElement && listenerAdded) {
        zohoChatElement.removeEventListener('click', handleClick);
      }
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);

  return null;
};

export default ZohoChatbot;
